

export default {
    data: function () {
        const mapStyleUrl = "https://maps.fischer.cz/styles/streets/style.json";
        return {
            clusterOptions: {},
            layerOptions: {
                maxZoom: 18,
                minZoom: 3,
                style: mapStyleUrl || "",
                preserveDrawingBuffer: true,
            },
            mapOptions: {
                zoomSnap: 0.5,
                scrollWheelZoom: false
            },
            hotelIcon: L.icon({
                iconUrl: process.env.NODE_ENV === 'development' ? "/Content/images/map/map-pin-default.png" : "/Content/images/map/map-pin-default.png",
                iconSize: [20, 35],
                iconAnchor: [11, 35],
            }),
            apartmentIcon: L.icon({
                iconUrl: process.env.NODE_ENV === 'development' ? "/Content/images/map/map-pin-apartment.png" : "/Content/images/map/map-pin-apartment.png",
                iconSize: [20, 35],
                iconAnchor: [11, 35],
            }),
            zoom: 8,
        }
    },
    methods: {
        getIcon: function (pin) {
            if(pin.hasOwnProperty("apartment") && pin.apartment){
                return this.apartmentIcon;
            }else{
                return this.hotelIcon;
            }
        },
    },
    computed: {
        bounds: function () {
            let pins = this.pins;
            //let bounds = pins.map(m => {return [m.position.lat, m.position.lng]});
            //let map_object = this.$refs.map.mapObject;
            //map_object.fitBounds(bounds);
            //return bounds;
            if(pins.length === 1){
                let p1 = [pins[0].position.lat, pins[0].position.lng];
                var rect = L.latLngBounds(p1, p1);
            }else{
                let p1 = [pins[0].position.lat, pins[0].position.lng];
                let p2 = [pins[1].position.lat, pins[1].position.lng];
                var rect = L.latLngBounds(p1, p2);
            }

            if (pins.length > 2) {
                let limit = pins.length;
                for (let i = 2; i < limit; i++) {
                    let location = this.pins[i].position;
                    let point = [location.lat, location.lng];
                    rect.extend(point);
                }
            }

            //let map_object = this.$refs.map.mapObject;
            //map_object.fitBounds(rect);
            return rect;
        },
        mapCenter() {
            let pins = this.pins;
            if (pins.length) {
                if (pins.length === 1) {
                    return L.latLng(
                        pins[0].position.lat,
                        pins[0].position.lng
                    );
                }
                const p1 = L.point(
                    pins[0].position.lat,
                    pins[0].position.lng
                );
                const p2 = L.point(
                    pins[1].position.lat,
                    pins[1].position.lng
                );
                const bounds = L.bounds(p1, p2);

                const result = pins.reduce((acc, item) => {
                        acc.extend(L.point(item.position.lat, item.position.lng));
                        return acc;
                    }, bounds)
                    .getCenter();
                return L.latLng(result.x, result.y);
            }
            return L.latLng(49.74375, 15.33863);
        },
    },
};
